<template>
  <div>跳转中</div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  created () {
    const url = window.location.hash
    // 提取查询字符串部分
    const queryString = url.split('?')[1];

    // 使用 URLSearchParams 解析查询参数
    const params = new URLSearchParams(queryString);
    const target = params.get('target');
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        window.open(target);
      } else if (isiOS) {
        window.location.href = target;
      } else {
        window.open(target, "_blank");
        window.close()
      }
  }
}
</script>